<template>
  <div v-if="post.copropriete">
    <strong v-if="variant !== 'pdfLandscape'">
      {{ $t('posts.coPropertyInformationTitle') }}
    </strong>

    <div :class="variant === 'pdfLandscape' ? 'pdf-style' : 'default-style'">
      <el-row :gutter="20">
        <ul class="info-list">
          <li v-if="post.copropriete">
            {{ $labels.copropriete }}
          </li>

          <li v-if="post.alur_syndic_en_procedure">
            <span class="label">
              {{ $labels.alur_syndic_en_procedure }} :
            </span>
            <span class="value">
              {{ post.alur_syndic_en_procedure ? 'oui' : 'non' }}
            </span>
          </li>

          <li v-if="post.charges_copropriete">
            <span class="label">
              {{ $labels.charges_copropriete }} :
            </span>
            <span class="value">
              {{ post.charges_copropriete }} {{ post.devise_iso_4217 }}/mois
            </span>
          </li>

          <li v-if="post.alur_nb_lots">
            <span class="label">
              {{ $labels.alur_nb_lots }} :
            </span>
            <span class="value">
              {{ post.alur_nb_lots }}
            </span>
          </li>
        </ul>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoProprieteInfoPdf',

  props: {
    post: {
      type: Object,
      required: true
    },
    variant: {
      type: String,
      default: 'default' // 'default' ou 'pdfLandscape'
    }
  }
}
</script>

<style scoped>
.info-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.info-list li {
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}

/* Labels */
.label {
  color: #555;
  margin-right: 4px;
}

/* Values */
.value {
  font-weight: 500;
}

/* Styles mode normal */
.default-style {
  font-size: 16px;
  text-align: justify;
  margin: 15px;
}

/* Styles mode PDF */
.pdf-style {
  font-size: 12px;
  text-align: justify;
  line-height: 1.5;
  margin: 0;
}

/* 🔥 important: force héritage pour éviter override Element UI */
.info-list,
.info-list li,
.info-list span {
  font-size: inherit;
}
</style>
